import { render, staticRenderFns } from "./modalChooseLanguage.vue?vue&type=template&id=1f62381e&"
import script from "./modalChooseLanguage.vue?vue&type=script&lang=js&"
export * from "./modalChooseLanguage.vue?vue&type=script&lang=js&"
import style0 from "./modalChooseLanguage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports